<script context="module">/**
 * This import is used by the Svelte SDK. Do not remove.
 */
</script>

<script>import { isEditing } from "../../functions/is-editing";
import { filterAttrs } from "../helpers";
import { setAttrs } from "../helpers";
export let backgroundSize = undefined;
export let backgroundPosition = undefined;
export let imgSrc = undefined;
export let altText = undefined;
export let image = undefined;
export let attributes = undefined;
function stringifyStyles(stylesObj) {
    let styles = "";
    for (let key in stylesObj) {
        const dashedKey = key.replace(/[A-Z]/g, function (match) {
            return "-" + match.toLowerCase();
        });
        styles += dashedKey + ":" + stylesObj[key] + ";";
    }
    return styles;
}
</script>

<img
  style={stringifyStyles({
    objectFit: backgroundSize || "cover",
    objectPosition: backgroundPosition || "center",
  })}
  key={(isEditing() && imgSrc) || "default-key"}
  alt={altText}
  src={imgSrc || image}
  {...filterAttrs(attributes, "on:", false)}
  use:setAttrs={filterAttrs(attributes, "on:", true)}
/>